const FILES_BASE_PATH = '/files';

export const PDF_DOWNLOADS = {
  cmtxBrochure: `${FILES_BASE_PATH}/cMTX_Brochure_ENG.pdf`,
  remoteMonitoringGuide: `${FILES_BASE_PATH}/Remote_Monitoring.pdf`,
  gatewayBrochure: `${FILES_BASE_PATH}/Gateway_Brochure_ENG.pdf`,
};
